const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy/marvy_mono/apps/pinktool/src/routes/_app/approvals.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { MouseEventHandler } from "react";
export const Route = createFileRoute("/_app/approvals")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});